import "./App.css";
import { LoginSignUp } from "./Components/LoginSignUp/LoginSignUp";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Header } from "./Components/Home/Header/Header";
import Story from "./Pages/Story";
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import Profile from "./Components/Profile/Profile";
import SavedStories from "./Components/LikedStories/LikedStories";
import OpenStory from "./Components/Home/OpenStory/OpenStory";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import LikedStories from "./Components/LikedStories/LikedStories";
import Quiz from "./Components/Home/Quiz/Quiz";
import MyStory from "./Pages/MyStory/MyStory";
import Admin from "./Components/admin.js";
import CreateOptions from './Pages/CreateStory/CreateOptions';
import MyStories from "./Components/MyStories/MyStories";
import QuizGeneration from "./Pages/QuizGeneration/QuizGeneration";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route
            path="/Story"
            element={<ProtectedRoute element={<Story />} />}
          />
          <Route
            path="/Story/:id"
            element={<ProtectedRoute element={<OpenStory />} />}
          />
          <Route
            path="/quiz/:id"
            element={<ProtectedRoute element={<Quiz />} />}
          />
          <Route
            path="/Contact"
            element={<ProtectedRoute element={<Contact />} />}
          />
          <Route
            path="/Profile"
            element={<ProtectedRoute element={<Profile />} />}
          />
          <Route
            path="/LikedStories"
            element={<ProtectedRoute element={<LikedStories />} />}
          />
          <Route
            path="/MyStory"
            element={<ProtectedRoute element={<MyStory />} />}
          />

          <Route path="/create" element={<CreateOptions />} />
          <Route path="/my-stories" element={<ProtectedRoute element={<MyStories />} />} />
          <Route 
            path="/generateQuiz/:storyId" 
            element={<ProtectedRoute element={<QuizGeneration />} />} 
          />

          <Route
            path="/admin"
            element={<ProtectedRoute element={<Admin />} />}
          />
          
          
          <Route
            path="/Login"
            element={
              <GoogleOAuthProvider clientId="1099266644156-67q2hh9l6jjgt13lh9dhui59uhbes4la.apps.googleusercontent.com">
                <LoginSignUp />
              </GoogleOAuthProvider>
            }
          />
          <Route
            exact
            path="/"
            element={<ProtectedRoute element={<Home />} />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
